export const READERSHIP_STATISTICS = [
  {
    statistic: '18',
    cadence: 'min',
    definition: 'Average time spent on page',
  },
  {
    statistic: '95',
    cadence: 'x/month',
    definition: 'Active reader engagement',
  },
  {
    statistic: '30',
    cadence: 'x/month',
    definition: 'Average reader engagement',
  },
  {
    statistic: '35',
    cadence: '%',
    definition: 'Newsletter open rate',
  },
];
